import VueWrapper from '@/components/core/Vue/vue.wrapper';
import ClientFooterComponent from '@/components/vuetify/client-footer/client-footer.component';
import {Component} from 'vue-property-decorator';
import {Location} from 'vue-router';

@Component({
    components: {
        ClientFooterComponent,
    },
})
export default class PaymentFailComponent extends VueWrapper {
    errorCode: string | null = null;
    errorMessage: string | null = null;
    orderId: string | null = null;

    planId: string | null = null;
    includeCircuit: string | null = null;
    extraUsers: string | null = null;

    created() {
        const query = this.$route.query;

        this.errorCode = (query.code as string) || (this.$t('PaymentPage.PaymentFail.unknownCode') as string);
        this.errorMessage = (query.message as string) || (this.$t('PaymentPage.PaymentFail.unknownError') as string);
        this.orderId = (query.orderId as string) || (this.$t('PaymentPage.PaymentFail.notApplicable') as string);

        this.planId = (query.planId as string) || null;
        this.includeCircuit = (query.includeCircuit as string) || 'false';
        this.extraUsers = (query.extraUsers as string) || '0';
    }

    get retryUrl(): Location | string {
        if (this.planId) {
            return {
                name: 'Checkout',
                query: {
                    planId: this.planId,
                    includeCircuit: this.includeCircuit,
                    extraUsers: this.extraUsers,
                },
            };
        }

        return '/';
    }
}
